import React, { useEffect, useState, Fragment } from "react";
import "./Footer.css";
import { IconButton, makeStyles, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Grid, MuiThemeProvider } from "@material-ui/core";
import pttwhite from "src/view/ReactApp/pttwhite.svg";

const useStyles = makeStyles((theme) => ({
  div1: {
    height: "32px",
    width: "100%",
    backgroundColor: "#ffffff",
  },
  div2: {
    height: "32px",
    width: "100%",
    backgroundColor: "#e4e6e5",
  },
  div3: {
    height: "64px",
    width: "100%",
    backgroundColor: "#e4e6e5",
    boxShadow: "0px -3px 20px #888",
  },
  divIn3: {
    height: "28px",
    width: "100%",
    backgroundColor: "#e4e6e5",
  },
  whiteText: {
    color: "#ffffff",
  },
  footerRoot: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "130px",
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.footerRoot}>
      <div id="FOOT">
        <div className="footer-row">
          <div className="footer-cell footer-icon">
            <img src={pttwhite} alt="logo" />
          </div>
          <div className="footer-cell">
            <b>บริษัท ปตท. จำกัด (มหาชน)</b>
            <div>
              555 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพฯ 10900
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className={classes.footerRoot}>
    //     <Grid container className={classes.div1}>
    //         <Grid item lg={3} md={3} sm={3} xs={3} style={{backgroundColor:'#004799'}}>
    //         </Grid>
    //         <Grid item lg={9} md={9} sm={9} xs={9} style={{backgroundColor:'#096ddd'}}>
    //         </Grid>
    //     </Grid>
    //     <Grid container className={classes.div2}></Grid>
    //     <Grid container  className={classes.div3}>
    //         <Grid item lg={12} md={12} sm={12} xs={12} style={{backgroundColor:'#004799'}}>
    //             <Grid container>
    //                 <Grid item lg={2} md={2} sm={2} xs={1}>
    //                 </Grid>
    //                 <Grid item lg={2} md={2} sm={2} xs={3}>
    //                     <img src={pttwhite} alt="logo" width="50" height="50" />
    //                 </Grid>
    //                 <Grid item lg={8} md={8} sm={8} xs={8}>
    //                 <Typography variant="subtitle2" style={{color:'#ffffff',marginTop:'4px'}}>
    //                     บริษัท ปตท. จำกัด (มหาชน)
    //                 </Typography>
    //                 <Typography variant="body2" style={{color:'#8c98ac'}}>
    //                     555 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพฯ 10900
    //                 </Typography>
    //                 </Grid>

    //             </Grid>
    //         </Grid>
    //         <Grid item lg={12} md={12} sm={12} xs={12} style={{backgroundColor:'#ffffff'}}>
    //             <Grid container className={classes.divIn3}>
    //             <Grid item lg={12} md={12} sm={12} xs={12} style={{backgroundColor:'#001f41'}}>
    //             </Grid>

    //         </Grid>
    //         </Grid>
    //     </Grid>

    // </div>
  );
};

export default Footer;
